import { Component } from "preact";
import { connectWithTranslations } from "../../common/helpers/translationsHelpers";
import actions from "../actions";
import { persistSettings } from "../../calendar-common/helpers/settingsHelper";
import {
    CALENDAR_VIEW,
    FILTER_TYPE,
    SETTINGS_SAVED_EVENT_NAME,
} from "../../calendar-common/constants";
import SettingsOptions from "./SettingsOptions";
import IconTimes from "../../common/components/icons/IconTimes";
import { GTM_ID, GA4EVENT} from "../constants";
import ConfirmationPopUp from "../../calendar-common/components/ConfirmationPopUp";

class SettingsContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            settings: {
                notificationSoundOn: null,
                view: null,
            },
            showAdvice: false,
        };
    }

    componentWillMount() {
        this.props.fetchLocalizations();
        this.props.initEventNotifications();
        this.props.openCloseListener();
        this.props.updateSettingsFromStorage();

        const { settings } = this.props;
        this.setState({ settings });
    }

    componentWillReceiveProps(nextProps) {
        const { settings } = nextProps;
        this.setState({ settings });
    }

    toggle = (item) => {
        item.checked = !item.checked;
    };

    onCheckboxChanged() {
        this.setState({
            settings: {
                ...this.state.settings,
                notificationSoundOn: !this.state.settings.notificationSoundOn,
            },
        });
    }

    onOptionChange(option) {
        // Disabled for premium view
        if (option != CALENDAR_VIEW.Configure_View_Premium)
            this.setState({
                settings: { ...this.state.settings, view: option },
            });
    }

    saveState() {
        return new Promise((resolve, reject) => {
            persistSettings(this.state.settings);
            this.props.saveSettings(this.state.settings);

            return resolve();
        });
    }
    close() {
        const { settings } = this.props;
        this.setState({ ...settings, showAdvice: false });
        this.props.close();
    }

    onApply = (items) => {
        const { settings } = this.props;
        if (
            settings.actualFilterType == FILTER_TYPE.custom &&
            settings.view != this.state.settings.view
        ) {
            this.setState({ ...this.state, showAdvice: true });
            return;
        }
        this.saveData(false, false, items);
    };

    saveData = (noChangeView, showAdvice, items) => {
        this.saveState().then(() => {
            const clockEvent = new CustomEvent(SETTINGS_SAVED_EVENT_NAME, {
                detail: { noChangeView: noChangeView, showAdvice: showAdvice },
            });
            document.dispatchEvent(clockEvent);
        });

        if (!items || items.lenght === 0) {
            this.setState({ showAdvice: false });
            this.props.close();
        } else {
            var toUnsubscribe = items
                .filter((x) => !x.checked)
                .map((x) => x.id);
            this.props.unsubscribeToEvents(toUnsubscribe).then(() => {
                this.props.close();
                this.setState({ showAdvice: false });
            });
        }
    };
    applySettings(data) {
        this.saveData(false, true, data);
    }

    cancel(data) {
        const { settings } = this.props;
        this.state.settings.view = settings.view;
        this.saveData(true, true, data);
    }
    render({ config, data, translate }) {
        return (
            config.show && (
                <div
                    class="fxs_widget fxs_cs_modal"
                    tabindex="-1"
                    role="dialog"
                    aria-hidden="true"
                >
                    <div
                        class={`fxs_cs_modal_content ${
                            this.state.showAdvice
                                ? "fxs_cs_modal_content_advice"
                                : ""
                        }`}
                    >
                        <button
                            type="button"
                            onClick={() => this.close()}
                            class="fxs_modal_close fxs_btn_icon close fxs_cs_modal_close"
                            data-dismiss="modal"
                            aria-label="Close Modal"
                            data-gtmid={
                                config.tracking && GTM_ID.CONFIGURATION_CLOSE
                            }
                            data-ga4event-clk-name={ config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                            data-ga4event-element = { config.tracking && GA4EVENT.ELEMENTS.CONFIGURATION_CLOSE}

                        >
                            <IconTimes />
                            <span class="fxs_skip">Close</span>
                        </button>
                        {this.state.showAdvice ? (
                            <ConfirmationPopUp
                                cancel={() => this.cancel(data)}
                                save={() => this.applySettings(data)}
                            ></ConfirmationPopUp>
                        ) : (
                            <SettingsOptions
                                onCheckboxChanged={() =>
                                    this.onCheckboxChanged()
                                }
                                notificationSoundOn={
                                    this.state.settings.notificationSoundOn
                                }
                                view={this.state.settings.view}
                                onOptionChange={(option) =>
                                    this.onOptionChange(option)
                                }
                                toggle={(item) => this.toggle(item)}
                                onApply={(data) => this.onApply(data)}
                            ></SettingsOptions>
                        )}
                    </div>
                </div>
            )
        );
    }
}

export default connectWithTranslations(
    "settings, config, data",
    actions
)(SettingsContainer);
